import { list, getUrl } from 'aws-amplify/storage';
import { ListOutputItemWithPath } from '@aws-amplify/storage/dist/esm/providers/s3/types';
import { S3File } from 'features/file-browser/state/fileAtoms';

export const fetchS3Objects = async (
  identityId: string,
  subpath: string
): Promise<S3File[]> => {
  try {
    const result = await list({
      path: `from-web-app/${identityId}/${subpath}`,
    });

    const s3Files = await Promise.all(result.items.map(async (item: ListOutputItemWithPath) => {
      const newPath = item.path as string;
      const newName = newPath.split('/').pop() || '';
      const newType = newName.split('.').pop() || '';

      const linkToStorageFile = await getUrl({
        path: newPath,
        options: {
          validateObjectExistence: false,
          expiresIn: 1800,
        },
      });

      return {
        name: newName,
        type: newType,
        lastModified: item.lastModified || new Date(0),
        size: (item.size as number / 1048576).toFixed(1) + 'MB',
        path: newPath,
        url: linkToStorageFile.url.toString()
      };
    }));
    return s3Files;
  } catch (error) {
    console.error(`Error listing S3 objects from ${subpath}:`, error);
    return [];
  }
};
